import API from '../.';

const login = (data) => API.post('/api/v1/users/login/', data);

export default login;
